import { apiDelete, apiGet, apiPatch, apiPost } from './client';

export type RoleScope = 'internal' | 'merchant';

export type RoleDto = {
  id: number;
  name: string;
  slug: string;
  description: string | null;
  scope: RoleScope;
  isSystem: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
};

export type RoleDetailDto = RoleDto & {
  userCount?: number;
};

export type PermissionDto = {
  id: number;
  key: string;
  name: string;
  description: string | null;
  module: string;
  sortOrder: number;
};

export const rolesApi = {
  list: (params: { scope?: RoleScope } = {}) => {
    const q = new URLSearchParams();
    if (params.scope) q.set('scope', params.scope);
    const qs = q.toString();
    return apiGet<{ rows: RoleDto[] }>(`/api/roles${qs ? `?${qs}` : ''}`);
  },
  get: (id: number) => apiGet<RoleDetailDto>(`/api/roles/${id}`),
  listPermissions: () => apiGet<{ rows: PermissionDto[] }>('/api/permissions'),
  getRolePermissions: (id: number) =>
    apiGet<{ permissionKeys: string[] }>(`/api/roles/${id}/permissions`),
  setRolePermissions: (id: number, permissionKeys: string[]) =>
    apiPatch<{ ok: true; roleId: number; added: number; removed: number; affectedUsers: number }>(
      `/api/roles/${id}/permissions`,
      { permissionKeys },
    ),
  create: (input: {
    name: string;
    slug: string;
    description?: string;
    scope: RoleScope;
  }) => apiPost<RoleDto>('/api/roles', input),
  update: (id: number, input: { name?: string; description?: string | null }) =>
    apiPatch<RoleDto>(`/api/roles/${id}`, input),
  remove: (id: number) => apiDelete<{ ok: true }>(`/api/roles/${id}`),
};
